export default __webpack_public_path__ + "static/media/checked.3b6898a5.png";